<template>
    <div>
        <div
          class="top-background-bloc"
          v-if="!notFoundContact"
        ></div>
        <div
          v-if="!notFoundContact"
          class="pro-main-title"
        >
            <div class="pt-5 pb-5 header w-100">
                <h1 class="mx-auto col-11">Votre Espace Pro</h1>
            </div>

            <div class="pro-main-container-bloc pt-5">
                <div class="mx-auto col-11">
                    <v-alert
                      class="mt-5"
                      style="margin-bottom: 40px"
                      dismissible
                      v-if="displayThanks && organism !== null"
                    >
                        <div class="d-md-flex justify-content-start">
<!--                            <div-->
<!--                              class="logo"-->
<!--                              v-if="logo !== null"-->
<!--                            >-->
<!--                                <v-img-->
<!--                                  height="100px"-->
<!--                                  max-width="300px"-->
<!--                                  position="center"-->
<!--                                  contain-->
<!--                                  :src="logo"-->
<!--                                ></v-img>-->
<!--                            </div>-->

                            <div>
                                <h4>Merci pour votre réponse !</h4>
                                <div>Votre Office de Tourisme vous remercie d'avoir mis à jour vos
                                    informations.
                                </div>
                            </div>
                        </div>
                    </v-alert>

                    <!--          <div-->
                    <!--            v-if="loaded && uskaFreemium && hasProviders && !hasUska"-->
                    <!--            id="uska-freemium-card"-->
                    <!--          >-->
                    <!--            <div id="content">-->
                    <!--              <h1><b>Découvrez la performance de votre visibilité en ligne gratuitement</b></h1>-->
                    <!--              <p>Votre espace évolue pour améliorer votre visibilité</p>-->
                    <!--              <a-->
                    <!--                class="uska-button w-fit"-->
                    <!--                :href="-->
                    <!--                  uskaFront +-->
                    <!--                  'onboarding/freemium?utm_content=' +-->
                    <!--                  token +-->
                    <!--                  '&utm_source=hubo_freemium&utm_medium=contact'-->
                    <!--                "-->
                    <!--              >-->
                    <!--                <img src="/images/logo_USKA_empty.png" />-->
                    <!--                <span>Découvrir Uska</span>-->
                    <!--                <v-icon color="white">mdi-chevron-right</v-icon>-->
                    <!--              </a>-->
                    <!--            </div>-->
                    <!--            <div id="image-container">-->
                    <!--              <img src="/images/uska_freemium.png" />-->
                    <!--            </div>-->
                    <!--          </div>-->

<!--                    <div id="uska-freemium-card" v-if="loaded && uskaFreemium && !hasUska-->
<!--                        && providersCount > 0">-->
<!--                        <div id="content">-->
<!--                            <h1><b>Découvrez la performance de votre visibilité en ligne gratuitement</b></h1>-->
<!--                            <p>Votre espace évolue pour améliorer votre visibilité</p>-->
<!--                            <v-btn color="primary" @click="openTypeFormModal = true" class="uska-button w-fit">-->
<!--                                <img src="/images/logo_USKA_empty.png" />-->
<!--                                <span>Découvrir Uska</span>-->
<!--                                <v-icon color="white">mdi-chevron-right</v-icon>-->
<!--                            </v-btn>-->
<!--                        </div>-->
<!--                        <div id="image-container">-->
<!--                            <img src="/images/uska_freemium.png" />-->
<!--                        </div>-->
<!--                    </div>-->

                    <div id="uska-freemium-card" v-else-if="loaded && uskaFreemium && !hasUska
                        && providersCount > 0">
                        <div id="content">
                            <h1><b>Vos clients vous trouvent-ils sur internet ?</b></h1>
                            <p>Découvrez la performance de votre visibilité en ligne gratuitement.</p>
                            <v-btn color="primary" @click="openTypeFormModal = true" class="uska-button w-fit">
                                <span>J'en profite</span>
                                <v-icon color="white">mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                        <div id="image-container">
                            <img src="/images/uska_freemium.png" />
                        </div>
                    </div>

                    <v-alert
                      class="mt-5"
                      style="margin-bottom: 40px"
                    >
                        <h4>Bienvenue sur votre espace !</h4>
                        <div>Vous trouverez l'ensemble des informations concernant vos activités touristiques
                            ci-dessous.
                        </div>

                        <div
                          class="mt-5 success-text"
                          v-if="loaded && cadhRequests.length === 0 && cmajRequests.length === 0"
                        >
                            <v-icon
                              color="success"
                              class="mr-2"
                            >check_circle
                            </v-icon
                            >
                            Vous n'avez plus de demandes en cours.
                        </div>
                    </v-alert>

                    <content-placeholders
                      :rounded="true"
                      v-if="!loaded"
                    >
                        <content-placeholders-heading style="width: 500px" />
                        <content-placeholders-img style="height: 100px" />
                        <content-placeholders-img style="height: 100px" />

                        <content-placeholders-heading style="width: 450px; margin-top: 50px" />
                        <content-placeholders-img style="height: 100px" />
                        <content-placeholders-img style="height: 100px" />
                    </content-placeholders>

                    <div v-if="firstBloc === 'CMAJ'">
                        <request-bloc
                          v-if="cmajRequests.length"
                          :title="majBlockTitle"
                          :requests="cmajRequests"
                        >
                        </request-bloc>

                        <request-bloc
                          v-if="cadhRequests.length"
                          :title="partenariatBlockTitle"
                          :requests="cadhRequests"
                        >
                        </request-bloc>
                    </div>

                    <div v-else>
                        <request-bloc
                          v-if="cadhRequests.length"
                          :title="partenariatBlockTitle"
                          :requests="cadhRequests"
                        >
                        </request-bloc>

                        <request-bloc
                          v-if="cmajRequests.length"
                          :title="majBlockTitle"
                          :requests="cmajRequests"
                        >
                        </request-bloc>
                    </div>

                    <div
                      v-if="(oldCadhRequests.length || oldCmajRequests.length) && loaded"
                      style="margin-bottom: 40px"
                    >
                        <pro-old-request
                          :old-cadh-requests="oldCadhRequests"
                          :old-cmaj-requests="oldCmajRequests"
                        >
                        </pro-old-request>
                    </div>
                </div>
            </div>

            <v-dialog v-model="openTypeFormModal" width="75%">
                <v-card>
                    <v-card-actions class="w-100 d-flex justify-content-end">
                        <v-btn icon dark @click="openTypeFormModal = false">
                            <v-icon class="text-secondary">mdi-close</v-icon>
                        </v-btn>
                    </v-card-actions>
                    <v-card-text>
                        <iframe :src="url"
                                style="width: 100%; height: 700px;border: none;">
                        </iframe>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>

        <div
          v-else
          class="text-center"
          style="height: calc(100vh - 55px)"
        >
            <div class="vertical-center w-100">
                <h2>La page que vous recherchez n'existe pas.</h2>
            </div>
        </div>
    </div>
</template>

<script>
import RequestBloc from "./RequestBloc"
import ProOldRequest from "./ProOldRequest"
import axios from "axios"
import { mapState } from "vuex"

export default {
    name: "ProDashboard",
    components: { ProOldRequest, RequestBloc },
    data() {
        return {
            token: null,
            organism: null,
            logo: null,
            uskaFreemium: false,
            cadhRequests: [],
            cmajRequests: [],
            cadhRequestsEnt: [],
            oldCadhRequests: [],
            oldCmajRequests: [],
            firstBloc: "CMAJ",
            notFoundContact: false,
            loaded: false,
            displayThanks: false,
            uskaFront: process.env.VUE_APP_USKA_FRONT_URL,
            webFormToken: null,
            partenariatBlockTitle: "Offres d'adhésion ou de partenariat en attente",
            majBlockTitle: "Demande de mise à jour en attente",
            hasProviders: false,
            url: "https://dahub-io.typeform.com/uskav4#contact_token=",
            category: null,
            providersCount: 0,
            otName: null,
            contactLastName: "",
            contactFirstName: "",
            openTypeFormModal: false,
            hasUska: false,
        }
    },
    methods: {
        async getSolicitations() {
            let res = await this.$http.get("professional/solicitations/" + this.token)

            if (res.body.success) {
                this.organism = res.body.data.organism
                this.logo = res.body.data.logo
                this.cadhRequests = res.body.data.cadhForms
                this.cmajRequests = res.body.data.cmajForms

                this.uskaFreemium = res.body.data.uskaFreemium ?? false
            } else {
                this.notFoundContact = res.body.data.notFoundContact
            }

            this.loaded = true

            this.setPartenariatBlockTitle()
            this.setMajBlockTitle()

            if (this.webFormToken !== undefined) {
                let type = this.findFormTypeByToken()

                if (type !== null) {
                    this.firstBloc = type

                    let requests

                    if (type === "CMAJ") {
                        requests = this.cmajRequests
                    } else {
                        requests = this.cadhRequests
                    }

                    let index = requests.findIndex((request) => request.token === this.webFormToken)

                    this.reorderRequests(requests, index)
                }
            }
        },
        async getProvidersContact() {
            const apiKey = process.env.VUE_APP_API_KEY_PH_HUBO
            const url = process.env.VUE_APP_API_URL + "/presence-hub/contact-providers/" + this.token + "?api_key=" + apiKey

            await axios.get(url).then((res) => {
                if (res.data.success && res.data.data.length) {
                    this.hasProviders = true
                }
            })
        },
        getOldSollicitations() {
            this.$http.get("professional/solicitations/old/" + this.token).then((res) => {
                this.oldCadhRequests = res.body.data.oldCadhForms
                this.oldCmajRequests = res.body.data.oldCmajForms
            })
        },
        findFormTypeByToken() {
            let type = null

            let isCmaj = this.cmajRequests.find((request) => request.token === this.webFormToken)
            let isCadh = this.cadhRequests.find((request) => request.token === this.webFormToken)

            type = isCmaj !== undefined ? "CMAJ" : null

            if (isCadh !== undefined) {
                type = "CADH"
            }

            return type
        },
        reorderRequests(requests, index) {
            if (index !== null) {
                let request = requests[index]

                requests.splice(index, 1)
                requests.unshift(request)
            }
        },
        setPartenariatBlockTitle() {
            let globalPartenariatKeys = []

            this.cadhRequests.forEach((request) => {
                globalPartenariatKeys.push(request.globalPartenariatConfig)
            })

            if (globalPartenariatKeys.length === 1 && globalPartenariatKeys[0] === "partenariat") {
                this.partenariatBlockTitle = "Offre de partenariat en attente"
            } else if (globalPartenariatKeys.length === 1 && globalPartenariatKeys[0] === "adhésion") {
                this.partenariatBlockTitle = "Offre d'adhésion en attente"
            } else {
                if (!globalPartenariatKeys.includes("partenariat") && globalPartenariatKeys.includes("adhésion")) {
                    this.partenariatBlockTitle = "Offres d'adhésion en attente"
                } else if (globalPartenariatKeys.includes("partenariat") && !globalPartenariatKeys.includes("adhésion")) {
                    this.partenariatBlockTitle = "Offres de partenariat en attente"
                }
            }
        },
        setMajBlockTitle() {
            if (this.cmajRequests.length > 1) {
                this.majBlockTitle = "Demandes de mises à jour en attente"
            }
        },
        async setUrl() {
            let res = await this.$http.get("professional/first-provider/" + this.token)

            let provider = res.body.data.provider
            this.providersCount = res.body.data.providersCount

            if (this.providersCount > 0) {
                let lastVersion = provider.last_version
                this.hasUska = res.body.data.hasUska

                if (lastVersion !== undefined) {
                    this.offerName = lastVersion.name

                    if (lastVersion.category !== null) {
                        this.category = lastVersion.category.name
                    }
                }
                this.otName = provider.user.account.name
                this.contactLastName = this.contact.last_name !== null ? this.contact.last_name : ""
                this.contactFirstName = this.contact.first_name !== null ? this.contact.first_name : ""

                this.url += this.token + "&mail=" + this.contact.email + "&prenom=" + this.contactFirstName + "&nom=" +
                  this.contactLastName + "&category=" + this.category + "&offer_name=" + this.offerName + "&telephone=" +
                  this.contact.phone + "&nb_offres=" + this.providersCount + "&ot_partenaire=" + this.otName +
                  "&sp_provenance_lead=onboarding_uska_typeform"+ "&uska_available=" + this.hasProviders
            }
        },
        loadHubSpotTracker() {
            let script = document.createElement("script")
            script.setAttribute("type", "text/javascript")
            script.setAttribute("src", "/js/__js.hs-scripts.com_2380813.js")
            script.setAttribute("id", "hs-script-loader")
            script.setAttribute("async", "")
            script.setAttribute("defer", "")
            document.head.appendChild(script)
        },
    },
    computed: {
        ...mapState("pro", ["contact"]),
    },
    async created() {
        if (process.env.NODE_ENV === "production") {
            this.loadHubSpotTracker()
        }

        this.token = this.$route.params.token

        this.webFormToken = this.$route.query.utm_content

        if (this.$route.query.displayThanks !== undefined) {
            this.displayThanks = true
        }

        this.$global.$on("remove-request", async () => {
            this.$global.loading = true
            await this.getSolicitations()
            this.$global.loading = false
        })

        this.getOldSollicitations()

        await this.getProvidersContact()

        await this.setUrl()

        await this.getSolicitations()
    },
    beforeDestroy() {
        this.$global.$off("remove-request")
    },
}
</script>
